import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBrain, FiHeart, FiTarget, FiUsers, FiArrowRight } = FiIcons;

const MethodologySection = () => {
  const methodology = [
    {
      title: "El Botón de Avanzar y la Conciencia del Ser",
      items: [
        { icon: FiBrain, text: "Desbloqueo emocional" },
        { icon: FiHeart, text: "Reprogramación del subconsciente" },
        { icon: FiTarget, text: "Reconexión cuerpo-mente" },
        { icon: FiHeart, text: "Mindful eating" },
        { icon: FiBrain, text: "Higiene del sueño" }
      ]
    },
    {
      title: "Hábitos de Éxito",
      items: [
        { icon: FiTarget, text: "Sistema de metas pequeñas" },
        { icon: FiBrain, text: "Desintoxicación digital" },
        { icon: FiHeart, text: "Autocompasión" },
        { icon: FiUsers, text: "Seguimiento y comunidad" }
      ]
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center mb-12">
            Tu Camino Hacia el Bienestar: Así Funciona ESTRATEGIA M.E.T.A.
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8 mb-8">
            {methodology.map((section, sectionIndex) => (
              <motion.div
                key={sectionIndex}
                initial={{ opacity: 0, x: sectionIndex === 0 ? -20 : 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: sectionIndex * 0.2 }}
                className="bg-white p-8 rounded-2xl shadow-lg"
              >
                <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6">
                  {section.title}
                </h3>
                <div className="space-y-4">
                  {section.items.map((item, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 10 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: index * 0.1 }}
                      className="flex items-center gap-3"
                    >
                      <div className="bg-blue-100 p-2 rounded-full">
                        <SafeIcon icon={item.icon} className="text-blue-600 text-lg" />
                      </div>
                      <span className="text-gray-700">{item.text}</span>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
          
          <div className="text-center">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="bg-blue-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-blue-700 transition-colors flex items-center gap-2 mx-auto shadow-lg"
            >
              Ver más sobre la estrategia M.E.T.A.
              <SafeIcon icon={FiArrowRight} className="text-xl" />
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MethodologySection;